<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-12">
                    <h2>{{ title }}</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <dl v-if="contract">
                                <dt class="col-sm-4">{{ $t('contract_status') }}</dt>
                                <dd class="col-sm-8">
                                    {{ $rights_status.filter(status => status.id == contract.rights_status)[0].name }}
                                </dd>
                                <dt class="col-sm-4">{{ $t('start') }}</dt>
                                <dd class="col-sm-8">{{ contract.start | dateFormat }}</dd>
                                <dt class="col-sm-4">{{ $t('end') }}</dt>
                                <dd class="col-sm-8">{{ contract.end | dateFormat }}</dd>
                                <dt class="col-sm-4">{{ $t('automatic_renewal') }}</dt>
                                <dd class="col-sm-8">
                                    <span :inner-html.prop="contract.self_renewal | yesno"/>
                                    <small
                                        v-if="contract.self_renewal">{{ $t('renewal_months') }}
                                        {{ contract.renewal_for_months }}</small>
                                </dd>
                                <dt class="col-sm-4">{{ $t('commission_percentage') }}</dt>
                                <dd class="col-sm-8">{{ contract.commission_percentage }}%</dd>
                                <dt class="col-sm-4">{{ $t('minimum_guarantee') }}</dt>
                                <dd class="col-sm-8">{{ contract.minimum_grant }}</dd>
                                <dt class="col-sm-4">{{ $t('rights_type') }}</dt>
                                <dd class="col-sm-8">{{ contract.righttype.map(type => type.name).join(', ') }}</dd>
                                <dt class="col-sm-4">{{ $t('exclusive_world') }}</dt>
                                <dd class="col-sm-8">
                                    <span :inner-html.prop="contract.exclusive_world | yesno"/>
                                    <small
                                        v-if="contract.exexclterritory.length > 0">
                                        {{ $t('exceptions') }}
                                        {{ contract.exexclterritory.map(country => country.name).join(', ') }}
                                    </small>
                                </dd>
                                <dt class="col-sm-4">{{ $t('nn_exclusive_world') }}</dt>
                                <dd class="col-sm-8">
                                    <span :inner-html.prop="contract.nn_exclusive_world | yesno"/>
                                    <small
                                        v-if="contract.exnnexclterritory.length > 0">
                                        {{ $t('exceptions') }}
                                        {{ contract.exnnexclterritory.map(country => country.name).join(', ') }}
                                    </small>
                                </dd>
                                <dt v-if="contract.exclterritory.length > 0" class="col-sm-4">
                                    {{ $t('territories_exclusive') }}
                                </dt>
                                <dd class="col-sm-8">
                                    <span>
                                        {{ contract.exclterritory.map(country => country.name).join(', ') }}
                                    </span>
                                </dd>
                                <dt v-if="contract.nnexclterritory.length > 0" class="col-sm-4">
                                    {{ $t('territories_nn_exclusive') }}
                                </dt>
                                <dd class="col-sm-8">
                                    <span>
                                        {{ contract.nnexclterritory.map(country => country.name).join(', ') }}
                                    </span>
                                </dd>
                                <dt class="col-sm-4">{{ $t('already_fvod') }}</dt>
                                <dd class="col-sm-8">
                                    <span :inner-html.prop="contract.published_fvod | yesno"/>
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import contracts from "../services/api/contracts";

export default {
    name: "Contract",
    data() {
        return {
            title: null,
            contract: null,
        }
    },
    methods: {
        async created() {
            this.$Progress.start()
            let response = await contracts.show(this.$route.params.id)
            this.contract = new Form(response.data.data)
            this.title = this.contract.movie.title_international + ' - ' + this.$t('main_terms')
            this.$Progress.finish();
        },
    },
    created() {
        this.created()
    }
}
</script>

<style scoped>

</style>
